'use strict';

const keyboardAccessibility = require('./keyboardAccessibility');

module.exports = function () {
    const countrySelectorLinks = document.querySelectorAll('.country-selector a, .mobile-country-selector li, .js-store-preferences-country-selector');

    if (countrySelectorLinks.length === 0) {
        return;
    }

    countrySelectorLinks.forEach(link => {
        link.addEventListener('click', event => {
            event.preventDefault();
            $.spinner().start();

            const pageElement = document.querySelector('.page');
            const action = pageElement.dataset.httpMethod === 'GET' ? pageElement.dataset.action : 'Home-Show';
            let queryString = new URLSearchParams(pageElement.dataset.querystring);
            queryString.delete('addtocart');
            queryString.delete('addressAdded');
            queryString.delete('addressUpdated');
            queryString.delete('addressDefaultSet');
            queryString = queryString.toString();
            const localeCode = link.dataset.locale;
            const localeCurrencyCode = link.dataset.currencycode;
            const countrySelector = event.target.closest('.js-country-selector');
            const payload = `?code=${localeCode}&queryString=${encodeURIComponent(queryString)}&CurrencyCode=${localeCurrencyCode}&action=${action}`;
            const payloadUrl = countrySelector.dataset.url + payload;

            fetch(payloadUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then(res => {
                if (res.ok) {
                    return res.json();
                }
                return Promise.reject(res);
            }).then(data => {
                if (data && data.redirectUrl) {
                    window.location.href = data.redirectUrl;
                }
            }).catch(() => {
                $.spinner().stop();
            });
        });
    });

    keyboardAccessibility(
        '.header-top-bar .country-selector',
        {
            9: function () { // tab
                const dropdownToggle = this.querySelector('.dropdown-toggle');

                if (dropdownToggle.classList.contains('show')) {
                    const eventClick = new Event('click');

                    dropdownToggle.dispatchEvent(eventClick);
                }
            }
        },
        function () {
            return this.querySelector('.dropdown-country-selector a');
        }
    );

    const countrySelector = document.querySelector('.header-top-bar .country-selector');
    if (countrySelector) {
        document.querySelector('.header-top-bar .country-selector').addEventListener('focusin', function (e) {
            if (e.target === this) {
                const eventClick = new Event('click');
                this.querySelector('.dropdown-toggle').dispatchEvent(eventClick);
            }
        });
    }
};
